import apiFetch from '../../../utils/fetch';

import {
    USER_AUTH_FACEBOOK_LOGIN,
    USER_AUTH_FACEBOOK_LOGOUT,
    USER_AUTH_SHOW_FACEBOOK_CREATE,
} from './mutation-types';
import {
    FACEBOOK_CREATE_USER,
    FACEBOOK_LOGIN,
} from '../../../constants/api-routes';


/** helpers **/
const CONTENT_TYPE_JSON = 'application/json';


/** Store **/
const getDefaultState = () => {
    return {
        showFacebookCreate: false,
        facebookToken: null,
    };
};

const state = {
    ...getDefaultState(),
    ...{
        facebookToken: localStorage.getItem('facebook-token') || null,
    }
};

const getters = {
    facebookToken: state => state.facebookToken,
    showFacebookCreate: state => state.showFacebookCreate,
};

function logout() {
    return {type: USER_AUTH_FACEBOOK_LOGOUT};
}

function login(facebookToken) {
    return {type: USER_AUTH_FACEBOOK_LOGIN, facebookToken};
}

function createUserByFB(show) {
    return {type: USER_AUTH_SHOW_FACEBOOK_CREATE, show};
}

const actions = {
    logout({commit}) {
        commit(logout());
    },
    async facebookCreate({commit, dispatch}, accessToken) {
        dispatch('user/auth/logout', null, {root: true});
        return apiFetch(FACEBOOK_CREATE_USER, {
            method: 'POST',
            data: {accessToken: accessToken},
            headers: {
                Accept: CONTENT_TYPE_JSON,
                'Content-Type': CONTENT_TYPE_JSON
            }
        })
            .then(({token}) => {
                dispatch('user/auth/logged', {token: token}, { root: true });
                commit(login(accessToken));
                commit(createUserByFB(false));
                dispatch('user/auth/hideModal', null, { root: true });
                dispatch('user/auth/getCurrent', null, { root: true });

            });
    },
    async setToken({commit}, accessToken){
        commit(login(accessToken));
    },
    async login({commit, dispatch, state}, accessToken) {
        let response = await apiFetch(FACEBOOK_LOGIN, {
            method: 'POST',
            data: {accessToken: accessToken},
            headers: {
                Accept: CONTENT_TYPE_JSON,
                'Content-Type': CONTENT_TYPE_JSON
            }
        }, true, false)
            .then(({token}) => {
                dispatch('user/auth/logged', {token: token, facebookToken: accessToken}, {root: true});
                commit(login(accessToken));
                dispatch('user/auth/hideModal', null, {root: true});
                dispatch('user/auth/getCurrent', null, {root: true});
            }).catch(e => {
                if (e.response.status === 404) {
                    dispatch('user/auth/showModal', null, {root: true});
                    commit(createUserByFB(true));
                }
            });
    },
    hideFacebookForm({commit}) {
        commit(createUserByFB(false));
    }
};

const mutations = {
    [USER_AUTH_FACEBOOK_LOGIN]: (state, {facebookToken}) => {
        state.facebookToken = facebookToken;
        localStorage.setItem('facebook-token', state.facebookToken);

    },
    [USER_AUTH_FACEBOOK_LOGOUT]: (state) => {
        state.facebookToken = null;
        localStorage.removeItem('facebook-token');
    },
    [USER_AUTH_SHOW_FACEBOOK_CREATE]: (state, payload) => {
        state.showFacebookCreate = payload.show;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user/facebook-auth.js